export async function MindfulnessDelete( mindfulnessId ) {
  const authToken = sessionStorage.getItem("token");
  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/mindfulness/${mindfulnessId}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}